import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { ProviderRate } from '../../_types/provider-rate';
import { ProvidersService } from 'src/app/modules/providers/_services/providers.service';
import { ProviderRatesService } from '../../_services/providers-rates.service';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-rate-provider',
    templateUrl: './rate-provider.component.html',
    styleUrls: ['./rate-provider.component.scss'],
    standalone: false
})
export class RateProviderComponent {

  public rateProviderFormGroup!: RxFormGroup;

  public rateProvider: ProviderRate = new ProviderRate();
  public providers: any[] = [];  

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private providerRatesService: ProviderRatesService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private providerService: ProvidersService,
    private loginService: LoginService
  ) {
    this.rateProviderFormGroup = this.formBuilder.formGroup<ProviderRate>(this.rateProvider) as RxFormGroup;
  }

  ngOnInit(): void {
    if (this.config.data.rateProviderId) {
      this.loadRateProvider(this.config.data.rateProviderId);
    } else {
      this.rateProvider.rateId = this.config.data.rateId;
      this.rateProviderFormGroup.patchValue(this.rateProvider);
    }
    this.loadProviders();

    this.allowWrite = this.loginService.hasPermission('PROVIDER_RATES.WRITE');
    this.allowDelete = this.loginService.hasPermission('PROVIDER_RATES.DELETE');
  }

  async loadRateProvider(id: string) {
    this.rateProvider = await firstValueFrom(this.providerRatesService.get(id));
    this.rateProviderFormGroup.patchValue(this.rateProvider);
  }

  async loadProviders() {
    let response = await firstValueFrom(this.providerService.all());
    this.providers = response.data;
  }

  async save() {    

    let valid = this.formValidationService.validateForm(this.rateProviderFormGroup);
    if (valid) {
      this.rateProvider = Object.assign(this.rateProvider, this.rateProviderFormGroup.value);

      await this.providerRatesService.save(this.rateProvider).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Operario asignado correctamente' });
          this.dynamicDialogRef.close();
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al asignar el operario' });
        }
      });
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea desasignar el proveedor?",
      header: "Desasignar proveedor",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.providerRatesService.delete(this.rateProvider.id).subscribe({
          next: () => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Proveedor desasignado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }
}
